import { render, staticRenderFns } from "./setPasswordComponent.vue?vue&type=template&id=6bc85b10"
import script from "./setPasswordComponent.vue?vue&type=script&lang=js"
export * from "./setPasswordComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports